import * as React from 'react'
import * as styles from './OverlayPage.module.scss';


interface OverlayPageProps {
    header?: React.ReactChild | React.ReactChild[]
    children: React.ReactChild | React.ReactChild[]
    footer?: React.ReactChild | React.ReactChild[]
}

export class OverlayPage extends React.Component<OverlayPageProps> {
    render() {
        return <>
            <div className={styles.header}>{this.props.header}</div>
            <div className={styles.body}>{this.props.children}</div>
            <div className={styles.footer}>{this.props.footer}</div>
        </>
    }
}